import { useContext } from 'react'
import { DomainContext } from '@/contexts/DomainContext'

export function useDomain() {
  const context = useContext(DomainContext)
  if (context === undefined) {
    throw new Error('useDomain must be used within a DomainProvider')
  }
  return context
}
